import {
    LoadingButton as MuiLoadingButton,
    LoadingButtonProps as MuiLoadingButtonProps,
} from "@mui/lab";

import Styles from "./Button.module.scss";
import { Spinner } from "../Spinner/Spinner";

export interface ButtonProps
    extends Pick<
        MuiLoadingButtonProps,
        | "color"
        | "className"
        | "disabled"
        | "endIcon"
        | "fullWidth"
        | "onClick"
        | "size"
        | "startIcon"
        | "type"
        | "variant"
    > {
    children: React.ReactNode;
    isLoading?: boolean;
    variant?: "contained" | "outlined";
    rounded?: boolean;
}

export function Button({
    className,
    children,
    disabled,
    endIcon,
    isLoading = false,
    rounded,
    startIcon,
    size = "medium",
    variant = "contained",
    ...rest
}: ButtonProps) {
    let loadingPosition: MuiLoadingButtonProps["loadingPosition"] = "center";
    if (endIcon) {
        loadingPosition = "end";
    } else if (startIcon) {
        loadingPosition = "start";
    }

    return (
        <MuiLoadingButton
            className={`${Styles["Button"]} ${Styles[`Button--${size}`]} ${
                isLoading ? Styles[`Button--loading`] : ""
            } ${variant === "outlined" ? Styles[`Button--outlined`] : ""} ${
                rounded ? Styles[`Button--rounded`] : ""
            } ${disabled ? Styles[`Button--disabled`] : ""} ${className}`}
            disabled={disabled}
            endIcon={endIcon}
            loading={isLoading}
            loadingIndicator={
                <Spinner
                    className={Styles["Button__spinner"]}
                    size={16}
                    thickness={variant === "contained" ? 5 : 3.6}
                />
            }
            loadingPosition={loadingPosition}
            startIcon={startIcon}
            variant={variant}
            {...rest}
        >
            {children}
        </MuiLoadingButton>
    );
}
